import React, {lazy} from 'react';
import {Switch, Route, useRouteMatch} from 'react-router-dom';
// import PickupDetailNoAuth from '../../container/pages/PickupDetailNoAuth';

const NotFound = lazy(() => import('../../container/pages/404'));
const Maintenance = lazy(() => import('../../container/pages/Maintenance'));
const Pricing = lazy(() => import('../../container/pages/PricingTable'));
const Gallery = lazy(() => import('../../container/pages/Gallery'));
const Faq = lazy(() => import('../../container/pages/Faq'));
const Search = lazy(() => import('../../container/pages/SearchResult'));
const Users = lazy(() => import('../../container/pages/Users'));
const AddUser = lazy(() => import('../../container/pages/AddUsers'));
const DataTable = lazy(() => import('../../container/pages/UserListDataTable'));
const Team = lazy(() => import('../../container/pages/Team'));

//custom
const Home = lazy(() => import('../../container/pages/Home'));
const CreateShipment = lazy(() => import('../../container/pages/CreateShipment'));
const CreateShipmentNew = lazy(() => import('../../container/pages/CreateShipment_new'));
const CreateShipmentNewUpload = lazy(() => import('../../container/pages/CreateShipment_new_upload'));
const ConfirmShipment = lazy(() => import('../../container/pages/ConfirmShipment'));
const SummaryShipment = lazy(() => import('../../container/pages/SummaryShipment'));
const Receipt = lazy(() => import('../../container/pages/Receipt'));
const ReceiptPickup = lazy(() => import('../../container/pages/ReceiptPickup'));
const ShipLabel = lazy(() => import('../../container/pages/ShipLabel'));
const ShipLabelV2 = lazy(() => import('../../container/pages/ShipLabelV2'));
const ShipLabelPickup = lazy(() => import('../../container/pages/ShipLabelPickup'));
const ShipLabelPickupV2 = lazy(() => import('../../container/pages/ShipLabelPickupV2'));
const CreatePickup = lazy(() => import('../../container/pages/CreatePickup'));
const Pickups = lazy(() => import('../../container/pages/Pickups'));
const Shipments = lazy(() => import('../../container/pages/Shipments'));
const CartShipments = lazy(() => import('../../container/pages/CartShipments'));
const PickupDetail = lazy(() => import('../../container/pages/PickupDetail'));
const ShipmentDetail = lazy(() => import('../../container/pages/ShipmentDetail'));
const CreditHistory = lazy(() => import('../../container/pages/CreditHistory'));
const Dropoff = lazy(() => import('../../container/pages/Dropoff'));
const Bills = lazy(() => import('../../container/pages/Bills'));
const BillInovice = lazy(() => import('../../container/pages/Bill_invoice'));

const PagesRoute = () => {
    const {path} = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/404`} component={NotFound}/>
            <Route path={`${path}/maintenance`} component={Maintenance}/>
            <Route path={`${path}/Pricing`} component={Pricing}/>
            <Route path={`${path}/gallery`} component={Gallery}/>
            <Route path={`${path}/faq`} component={Faq}/>
            <Route path={`${path}/search`} component={Search}/>
            <Route path={`${path}/users`} component={Users}/>
            <Route path={`${path}/add-user`} component={AddUser}/>
            <Route path={`${path}/dataTable`} component={DataTable}/>
            <Route path={`${path}/team`} component={Team}/>

            {/* custom */}
            <Route exact path={path} component={Home}/>
            {/*<Route path={`${path}/create-shipment_upload/:id`} component={CreateShipment}/>*/}
            {/*<Route path={`${path}/create-shipment_upload/`} component={CreateShipment}/>*/}
            {/*<Route path={`${path}/create-shipment_upload_stl/:id`} component={CreateShipment}/>*/}
            {/*<Route path={`${path}/create-shipment_upload_stl/`} component={CreateShipment}/>*/}
            <Route path={`${path}/create-shipment_upload_2/:id`} component={CreateShipmentNewUpload}/>
            <Route path={`${path}/create-shipment_upload_2/`} component={CreateShipmentNewUpload}/>
            <Route path={`${path}/create-shipment/:id`} component={CreateShipmentNew}/>
            <Route path={`${path}/create-shipment/`} component={CreateShipmentNew}/>
            <Route path={`${path}/confirm-shipment/:id`} component={ConfirmShipment}/>
            <Route path={`${path}/summary-shipment/:id`} component={SummaryShipment}/>
            <Route path={`${path}/receipt/:id`} component={Receipt}/>
            <Route path={`${path}/receipt-pickup/:id`} component={ReceiptPickup}/>
            <Route path={`${path}/ship-label/:id`} component={ShipLabel}/>
            <Route path={`${path}/ship-labelV2/:id`} component={ShipLabelV2}/>
            <Route path={`${path}/ship-label-pickup/:id`} component={ShipLabelPickup}/>
            <Route path={`${path}/ship-label-pickupV2/:id`} component={ShipLabelPickupV2}/>
            <Route path={`${path}/create-pickup`} component={CreatePickup}/>
            <Route path={`${path}/pickups`} component={Pickups}/>
            <Route path={`${path}/bill_invoice`} component={BillInovice}/>                  
            <Route path={`${path}/shipments/:query`} component={Shipments}/>
            <Route path={`${path}/shipments`} component={Shipments}/>
            <Route path={`${path}/cartshipments/:query/:page`} component={CartShipments}/>
            <Route path={`${path}/cartshipments`} component={CartShipments}/>
            <Route path={`${path}/pickup/:id`} component={PickupDetail}/>
            <Route path={`${path}/shipment/:id`} component={ShipmentDetail}/>
            <Route path={`${path}/mycredit/`} component={CreditHistory}/>
            <Route path={`${path}/dropoff/`} component={Dropoff}/>
            <Route path={`${path}/bills/`} component={Bills}/>
        </Switch>
    );
};

export default PagesRoute;
